<template>
  <BaseModal
    v-model="visible"
    class="language-switcher"
    :title="$t('common.selectALanguage')"
  >
    <ul class="language-switcher__list u-margin-8x u-padding-0x">
      <li
        v-for="locale in locales"
        :key="locale.code"
        :class="{ 'text-right': locale.rtl }"
        data-test="language-picker-locales"
      >
        <SvgIcon v-if="locale.code === activeLocale" name="tick" />
        <BaseButton
          :data-test="`language-picker-locale${
            locale.code === activeLocale ? '-selected' : ''
          }`"
          variant="link"
          :data-cy="`language-locale-${locale.code}`"
          @click.native="changeLocale(locale.code)"
        >
          {{ locale.name }}
        </BaseButton>
      </li>
    </ul>
  </BaseModal>
</template>

<script lang="ts">
import Vue, { defineComponent } from 'vue';
import config from '@/common/config';
import { prefStorage } from '@te/cdev-utils';
import { persistLocale } from '@/common/helpers/language-switcher';
import { SvgIcon, BaseButton, BaseModal } from '@te/cdev-design-system';

export default defineComponent({
  name: 'LanguageSwitcher',

  components: {
    SvgIcon,
    BaseButton,
    BaseModal
  },

  data: () => ({
    locales: config.locales
  }),
  computed: {
    activeLocale(): string {
      return Vue.config.lang;
    },
    visible: {
      get(): boolean {
        return this.$store.state.languageSwitcher.visible;
      },
      set(value: boolean) {
        this.$store.commit('languageSwitcher/SET_VISIBILITY', value);
      }
    }
  },
  methods: {
    hideLanguageSwitcher() {
      this.$store.commit('languageSwitcher/SET_VISIBILITY', false);
    },
    changeLocale(locale: string) {
      Vue.config.lang = locale;
      prefStorage.set('locale', locale);

      const zdLocale = config.locales.find(
        (localeItem) => localeItem.code === locale && !!localeItem.zdCode
      );
      const zdLocaleCode = zdLocale ? zdLocale.zdCode : 'en-gb';
      prefStorage.set('locale-hc', zdLocaleCode);

      persistLocale(locale, this.$route.path).then(() => {
        window.location.reload();
      });
    }
  }
});
</script>

<style lang="scss">
.language-switcher {
  &__list {
    list-style-type: none;
  }
}
</style>
